import { loadComponent } from './utils/componentLoader.js';
import initGnav from './components/_gnav.js';
import initFAQList from './components/_faq-list.js';
import initTopLoading from './components/_top-loading.js';
import initTopLetters from './components/_top-letters.js';
import initTopTitle from './components/_top-title.js';
import initTopCatchphrase from './components/_top-catchphrase.js';

/**
 * selector: トリガーとなる要素のセレクタ(存在チェックのため)
 * init: トリガーする関数名
 */
const components = [
    { selector: '.js-gnav-btn', init: initGnav },
    { selector: '.js-faq-toggle', init: initFAQList },
    { selector: '#js-loading-svg', init: initTopLoading },
    { selector: '.js-section-title', init: initTopTitle },
    { selector: '.js-catchphrase', init: initTopCatchphrase },
];

document.addEventListener('DOMContentLoaded', () => {
    components.forEach(({ selector, init }) => {
        loadComponent(selector, init);
    });

    // TOP - レターアニメーション用
    if (document.querySelector('.js-catch-copy-letters')) {
        document.addEventListener('loadingComplete', () => {
            console.log('カスタムイベント発生')
            loadComponent('.js-catch-copy-letters', initTopLetters);
        })
    }
});
